import React from "react";
import SensorBase from "./SensorBase";
import { TCustomProcessFn } from "../types";
import { TDataItem, TSensorDataResponse } from "../../../services/sensorData.service";
import { generateColorForItem } from "../util";

const FIELD = "soilTemp";
const UNIT = "C";

const customProcessFn: TCustomProcessFn = (
  graphData: TSensorDataResponse 
) => {

  const updatedSample = (graphData.data ?? []).map((item:TDataItem) => ({
    ...item,
    color: generateColorForItem(
      Number(item.soilTemp),
      item.minThresholdValue,
      item.minOptimalValue,
      item.maxOptimalValue,
      item.maxThresholdValue
    ),   
  }));

  return {
    sample: updatedSample,  
    min: graphData.min,  
    max: graphData.max,  
    avg: graphData.avg,  
    color: updatedSample.map((item) => item.color),  
  };
};


const SoilTemperature: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT} customProcessFn={customProcessFn}></SensorBase>
  );
};

export default SoilTemperature;
